module.exports = require("swa-bootstrap-corporate-landing-home-page/meta-tags.corporate");